import { FULL_HD, HD } from '@bedrock-rdk/constants';

export const BLOCK_GAP = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export * from './customer/default/exploreCatalogue.constants';
